const validateEnv = require('./src/utils/validateEnv');

const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: process.env.GATSBY_SITE_URL,
    gaTrackingId: 'UA-23867277-2',
  },
  realm: {
    review_db: {
      db_name: 'aiidprod',
      db_collection: 'submissions',
    },
    production_db: {
      db_name: 'aiidprod',
      db_history_name: 'history',
      db_custom_data: 'customData',
      db_collection: 'incidents',
      db_auth: 'auth',
    },
  },
  header: {
    logo: '/logos/White_Transparent_AIID_short.png',
    logoMobile: '/White_Transparent_AIID.png',
    logoLink: '/',
    title: ' AI Incident Database',
    githubUrl: 'https://github.com/responsible-ai-collaborative/aiid',
    facebookUrl: 'https://www.facebook.com/IncidentsDB',
    linkedInUrl: 'https://www.linkedin.com/company/responsible-ai-collaborative',
    helpUrl: '',
    tweetText: '',
    social: `<li>
		    <a href="https://twitter.com/IncidentsDB" target="_blank" rel="noopener">
		      <div class="twitterBtn">
		        <img src='/twitter-brands-block.svg' alt={'Twitter'}/>
		      </div>
		    </a>
		  </li>`,
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID || 'JD5JCVZEVS',
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY || 'c5e99d93261645721a1765fe4414389c',
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
      featured: [
        /* { <report_number>: <priority> }
         *
         * (The higher the priority, the earlier an item will appear in the initial results)
         */
        { 23: 2 }, // Is Starbucks shortchanging its baristas?
        { 1967: 1 }, // Tweet: @MarietjeSchaake
        { 1551: 1 }, // Hundreds of AI tools have been built to catch covid. None of them helped.
        { 835: 1 }, // LinkedIn’s search algorithm apparently favored men until this week
        { 1470: 1 }, // The Death and Life of an Admissions Algorithm
        { 1118: 1 }, // That Viral 'FaceApp' Is Making Everyone Look Whiter
        { 1773: 1 }, // Chess robot goes rogue, breaks seven-year-old player's finger
        { 1509: 1 }, // Humanoid Robot Keeps Getting Fired From His Jobs
        { 1245: 1 }, // Robot Stabs A Man To Death At A Factory In Haryana's Manesar!
        { 679: 1 }, // A.I. Video Depicting Barack Obama Shows Dangers of Fake News
        { 1606: 1 }, // Driverless car starts to pull away after being stopped by police
        { 1374: 1 }, // Tay (bot)
        { 1065: 1 }, // Centrelink robo-debt 'abject failure' and arguably unlawful, Victoria Legal Aid says
        { 1543: 1 }, // How Wrongful Arrests Based on AI Derailed 3 Men's Lives
        { 1505: 1 }, // Students of color are getting flagged to their teachers because testing software can’t see them
        { 1468: 1 }, // TikTok Deleted My Account Because I’m a Latina Trans Woman
        { 1539: 1 }, // Why Stanford Researchers Tried to Create a ‘Gaydar’ Machine
        { 1420: 1 }, // South Korean AI chatbot pulled from Facebook after hate speech towards minorities
        { 101: 1 }, // Google Photo App Labels Black Couple 'Gorillas'
        { 12: 1 }, // YouTube says it will crack down on bizarre videos targeting children
        { 368: 1 }, // Because Stanislav Petrov reported a computer malfunction in 1983, we know him today as "The man who saved the world"
        { 1427: 1 }, // Fired by Bot at Amazon: ‘It’s You Against the Machine’
        { 392: 1 }, // 'Flash Crash' arrest shakes investors' confidence
        { 595: 1 }, // Chinese AI traffic cam mistook a bus ad for a human and publicly shamed the CEO it depicted for jaywalking
        { 1235: 1 }, // Security robot 'drowns itself' in office fountain
        { 45: 1 }, // Google's Anti-Bullying AI Mistakes Civility for Decency
        { 620: 1 }, // Is AI Sexist?
        { 519: 1 }, // TV news report prompts viewers' Amazon Echo devices to order unwanted dollhouses
      ],
    },
  },
  sidebar: {
    navConfig: [
      { title: 'Welcome to the AIID', label: 'welcome', url: '/', items: [] },
      { title: 'Spatial View', label: 'spatial', url: '/summaries/spatial/', items: [] },
      { title: 'Table View', label: 'incidents', url: '/apps/incidents/', items: [] },
      { title: 'List View', label: 'list', url: '/summaries/incidents/', items: [] },
      { title: 'Entities', label: 'entities', url: '/entities/', items: [] },
      { title: 'Taxonomies', label: 'taxonomies', url: '/taxonomies/', items: [] },
      { title: 'Random Incident', label: 'random', url: '/random/', items: [] },
      { title: 'Blog', label: 'blog', url: '/blog/', items: [] },
      { title: 'AI News Digest', label: 'newsdigest', url: '/apps/newsdigest/', items: [] },
    ],
    frontline: true,
    ignoreIndex: false,
  },
  footer: {
    navConfig: [
      {
        title: 'Research',
        items: [
          {
            title: 'Defining an “AI Incident”',
            label: '1-criteria',
            url: '/research/1-criteria',
          },
          {
            title: 'Defining an “AI Incident Response”',
            label: '5-response',
            url: '/research/5-response',
          },
          { title: 'Database Roadmap', label: '2-roadmap', url: '/research/2-roadmap' },
          {
            title: 'Related Work',
            label: '4-related-work',
            url: '/research/4-related-work',
          },
          {
            title: 'Download Complete Database',
            label: 'snapshots',
            url: '/research/snapshots',
          },
        ],
      },
      {
        title: 'Project and Community',
        items: [
          { title: 'About', label: 'about', url: '/about', items: [] },
          { title: 'Contact and Follow', label: 'contact', url: '/contact' },
          { title: 'Apps and Summaries', label: 'about_apps', url: '/about_apps' },
          { title: 'Editor’s Guide', label: 'editors-guide', url: '/editors-guide' },
          {
            title: 'Submission Leaderboard',
            label: 'leaderboard',
            url: '/summaries/leaderboard/',
          },
        ],
      },
      {
        title: 'Incidents',
        items: [
          {
            title: 'All Incidents in List Form',
            label: 'all-incidents',
            url: '/summaries/incidents',
          },
          { title: 'Flagged Incidents', label: 'flagged', url: '/summaries/flagged' },
          { title: 'Submission Queue', label: 'submitted', url: '/apps/submitted' },
          { title: 'Classifications View', label: 'classifications', url: '/apps/classifications' },
          { title: 'Taxonomies', label: 'taxonomies', url: '/taxonomies' },
        ],
      },
    ],
  },
  siteMetadata: {
    title: 'Artificial Intelligence Incident Database',
    description: 'a collection of intelligent system harms in the real world ',
    ogImage: 'https://incidentdatabase.ai/logos/AIID_1000x1000px.png',
    docsLocation: '/',
    favicon: '/favicon.png',
    twitterAccount: '@IncidentsDB',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'The Artificial Intelligence Incident Database',
      short_name: 'AIID',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
  cloudinary: {
    cloudName: 'pai',
  },
  mongodb: {
    connectionString: process.env.MONGODB_CONNECTION_STRING,
    replicaSet: process.env.MONGODB_REPLICA_SET,
    translationsConnectionString: process.env.MONGODB_TRANSLATIONS_CONNECTION_STRING,
  },
  google: {
    mapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
  },
  i18n: {
    availableLanguages: String(process.env.GATSBY_AVAILABLE_LANGUAGES).split(',') || ['en'],
    translateApikey: process.env.GOOGLE_TRANSLATE_API_KEY,
    defaultLanguage: 'en',
  },
  discover: {
    taxa: ['CSETv0', 'CSETv1', 'GMF', 'MIT'],
  },
  cloudflareR2: {
    accountId: process.env.CLOUDFLARE_R2_ACCOUNT_ID,
    accessKeyId: process.env.CLOUDFLARE_R2_ACCESS_KEY_ID,
    secretAccessKey: process.env.CLOUDFLARE_R2_SECRET_ACCESS_KEY,
    bucketName: process.env.CLOUDFLARE_R2_BUCKET_NAME,
    publicBucketUrl: process.env.GATSBY_CLOUDFLARE_R2_PUBLIC_BUCKET_URL,
  },
  snippetMaxCharactersDefaultByDomain: {
    // When reports are viewed in the UI,
    // only a certain number of characters should be shown.
    // Beyond that, we direct users to the original source.
    // This maximum number of characters to show
    // is stored for each a submission or report document
    // in the `snippet_max_characters` field.
    // This is set upon submission of a report,
    // and the default value is based on the source domain.
    // The mapping of domains to default character limits is specified here.
    // For example:
    //
    // "example.org": 10000,
    // "example.com": 500,
    //
    // If no value is specified for the domain,
    // then `snippet_max_characters` is set to 1 million.
    // Changing the values here _does not_ affect existing reports,
    // only new submissions.
  },
};

const requiredEnvs = {
  GATSBY_SITE_URL: process.env.GATSBY_SITE_URL,
  GATSBY_AVAILABLE_LANGUAGES: process.env.GATSBY_AVAILABLE_LANGUAGES,
  // TODO: These are also required and should be validated.
  // GATSBY_ALGOLIA_SEARCH_KEY: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  // GATSBY_ALGOLIA_APP_ID: process.env.GATSBY_ALGOLIA_APP_ID,
  // ALGOLIA_ADMIN_KEY: process.env.ALGOLIA_ADMIN_KEY,
  // GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
  // GOOGLE_TRANSLATE_API_KEY: process.env.GOOGLE_TRANSLATE_API_KEY,
  // CLOUDFLARE_R2_ACCOUNT_ID: process.env.CLOUDFLARE_R2_ACCOUNT_ID,
  // CLOUDFLARE_R2_ACCESS_KEY_ID: process.env.CLOUDFLARE_R2_ACCESS_KEY_ID,
  // CLOUDFLARE_R2_SECRET_ACCESS_KEY: process.env.CLOUDFLARE_R2_SECRET_ACCESS_KEY,
  // CLOUDFLARE_R2_BUCKET_NAME: process.env.CLOUDFLARE_R2_BUCKET_NAME,
  // GATSBY_CLOUDFLARE_R2_PUBLIC_BUCKET_URL: process.env.GATSBY_CLOUDFLARE_R2_PUBLIC_BUCKET_URL,
};

validateEnv(requiredEnvs);

module.exports = config;
